import { effectsRegistry } from "../registry";
import { blurEffectDefinition } from "./blur";
import { contrastEffectDefinition } from "./contrast";
import { saturationEffectDefinition } from "./saturation";
import { exposureEffectDefinition } from "./exposure";
import { vignetteEffectDefinition } from "./vignette";

const defaultEffects = [
	blurEffectDefinition,
	contrastEffectDefinition,
	saturationEffectDefinition,
	exposureEffectDefinition,
	vignetteEffectDefinition,
];

export function registerDefaultEffects(): void {
	for (const definition of defaultEffects) {
		if (effectsRegistry.has(definition.type)) {
			continue;
		}
		effectsRegistry.register({
			key: definition.type,
			definition,
		});
	}
}
